import React from 'react';
import loader from 'common/images/loader.gif';
import SplashScreenPageWrapper from './SplashScreenPageWrapper';
import SplashScreenLogo from './SplashScreenLogo';

const SplashScreen = () => (
  <SplashScreenPageWrapper>
    <SplashScreenLogo src={loader} />
  </SplashScreenPageWrapper>
);

export default SplashScreen;



// WEBPACK FOOTER //
// ./src/blocks/SplashScreen/index.jsx